function initializeAddressAutocomplete(id) {
  const element = document.getElementById(id);

  if (element) {
    const options = {
      fields: ["address_components"],
      types: ["address"],
    };

    const autocomplete = new google.maps.places.Autocomplete(element, options);
    google.maps.event.addListener(autocomplete, 'place_changed', onPlaceChanged);
  }
}

function onPlaceChanged() {
  const place = this.getPlace();
  let streetNumber = '';
  let route = '';

  for (const component of place.address_components) {
    for (const actualType of component.types) {
      switch (actualType) {
        case 'street_number':
          streetNumber = component.long_name;
          break;
        case 'route':
          route = component.long_name;
          break;
        case 'locality': {
          const cityElement = document.querySelector('.city');
          if (cityElement) cityElement.value = component.short_name;
          break;
        }
        case 'postal_code': {
          const postalElement = document.querySelector('.postal-code');
          if (postalElement) postalElement.value = component.short_name;
          break;
        }
        case 'country': {
          const countryElement = document.querySelector('.country');
          if (countryElement) countryElement.value = component.short_name;
          break;
        }
      }
    }
  }

  const addressField = document.querySelector('.street-address');
  if (addressField) {
    addressField.value = [streetNumber, route].filter(Boolean).join(' ');
  }
}

if (typeof google !== 'undefined') {
  google.maps.event.addDomListener(window, 'load', function () {
    initializeAddressAutocomplete('user_input_autocomplete_address');
    initializeAddressAutocomplete('legal_input_autocomplete_address');
  });
}
